const salesReport = {
  statisticsByStatus: 'Estadísticas por estado',
  statisticsByPayments: 'Estadísticas por pagos',
  from: 'desde',
  till: 'hasta',
  myClients: 'Mis clientes',
  newClients: 'Nuevos clientes',
  showing: 'mostrando',
  usersOf: 'usuarios',
  noUsersFound: 'no se encontraron usuarios',
  managerSuccessfullyChanged: 'Gestor cambiado correctamente',
  lastPayments: 'Últimos pagos',
  lastPaymentsOf: 'pagos',
  noSalesReportLastPaymentFound: 'Informe de ventas, último pago no encontrado',
  pickReportRange: 'Seleccionar rango de informe',
  pickUser: 'Seleccionar usuario',
  toolbar: {
    totalClients: 'Número total de clientes',
    activeClients: 'Activo clientes',
    paymentsCommited: 'Pagos realizados',
    myPaymentsTotal: 'Importe total de mis pagos',
  },
  actionDropdown: {
    changeStatus: 'Cambiar estado',
    statusHistory: 'Historial de estados',
    editUser: 'Editar usuario',
  },
  modal: {
    clientStatusAndNotes: 'Estado y notas del cliente',
    status: 'Estado',
    note: 'Nota',
    statusChanged: 'Nueva nota o estado añadido'
  }
};
export default salesReport;
